import { Card, Box, Flex, Heading, Image } from '@chakra-ui/react'

interface GeneralContainerProps {
  children: JSX.Element
}

export default function GeneralContainer({ children }: GeneralContainerProps) {
  return (
    <Card border="1px solid" borderColor="borderColor" rounded="md" bg="bgContent" p={2} gap={2} w="full">
      <Flex alignItems="center" gap={2}>
        <Image
          src="https://app.milanote.com/media/p/images/1RnziZ1rFRbBc7/nUX/Logo-simplificada.jpg?w=display&v=2&elementId=1TxS2J1Ha3Xb48"
          alt="Logo Impacto"
          w="48px"
          h="48px"
          rounded={'md'}
        />
        <Heading fontSize="lg">Geral</Heading>
      </Flex>
      <Box w="full">{children}</Box>
    </Card>
  )
}
